import { useTranslation } from 'react-i18next'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { conversionFactors } from '@jupi/shared'

// The factors the weight & balance figures are converted with, so any of
// them can be checked by hand. `density` is the fuel's kg per litre.
export default function ConversionFactorsCard({ density }: { density: number }) {
  const { t } = useTranslation()
  const c = conversionFactors(density)
  const rows: [string, string, string?][] = [
    [t('plan.worked.factorMass'), `1 kg = ${c.lbPerKg.toFixed(4)} lb`, `1 lb = ${c.kgPerLb.toFixed(6)} kg`],
    [t('plan.worked.factorVolume'), `1 USG = ${c.litresPerUsg.toFixed(4)} l`, `1 l = ${c.usgPerLitre.toFixed(4)} USG`],
    [t('plan.worked.factorLength'), `1 m = ${c.inchesPerMetre.toFixed(4)} in`, `1 in = ${c.metresPerInch.toFixed(4)} m`],
    [t('plan.worked.factorMoment'), `1 kg·m = ${c.lbInPerKgm.toFixed(2)} lb·in`],
    [
      t('plan.worked.factorDensity'),
      `${c.densityKgPerLitre.toFixed(2)} kg/l`,
      `${c.densityKgPerUsg.toFixed(3)} kg/USG = ${c.densityLbPerUsg.toFixed(2)} lb/USG`,
    ],
  ]
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {t('plan.worked.factors')}
        </Typography>
        <Table size="small">
          <TableBody>
            {rows.map(([label, a, b]) => (
              <TableRow key={label}>
                <TableCell sx={{ pl: 0 }}>{label}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace' }} colSpan={b ? 1 : 2}>
                  {a}
                </TableCell>
                {b ? <TableCell sx={{ fontFamily: 'monospace', pr: 0 }}>{b}</TableCell> : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
